module.exports = __webpack_public_path__ + "img/rank_more03.edd72213.png";